import apiClient from './apiClient';

export const pdsIntegrationApi = {
  get: async () => {
    const response = await apiClient.get('/pds-integration');
    return response.data;
  },

  save: async (data) => {
    const response = await apiClient.post('/pds-integration', data);
    return response.data;
  },

  delete: async () => {
    const response = await apiClient.delete('/pds-integration');
    return response.data;
  },

  testConnection: async () => {
    const response = await apiClient.post('/pds-integration/test');
    return response.data;
  },

  triggerSync: async () => {
    const response = await apiClient.post('/pds-integration/sync');
    return response.data;
  },

  getStatus: async () => {
    const response = await apiClient.get('/pds-integration/status');
    return response.data;
  },

  getLogs: async (params = {}) => {
    const response = await apiClient.get('/pds-integration/logs', { params });
    return response.data;
  },
};
